import "./portfolio.css";
import React from "react";

// 👉 Replace these imports with your actual screenshots later
import IMG1 from "../../assets/samrat-group.png";
import IMG2 from "../../assets/samrat-frame.png";
import IMG3 from "../../assets/ex-stock.png";
import IMG4 from "../../assets/eyemate.png";
import IMG5 from "../../assets/Esate.png";
import IMG6 from "../../assets/explore.png";

const Portfolio = () => {
  const projects = [
    {
      id: 1,
      title: "Samrat Group",
      img: IMG1,
      description: "Corporate website for Samrat Group with modern UI and responsive design.",
      technologies: "React | Tailwind | Node.js | Express",
      link: "https://www.samrat-movies.com.np/",
      github: "https://github.com/Mandip69/Samrat-Group",
    },
    {
      id: 2,
      title: "Samrat Frame",
      img: IMG2,
      description: "Frame showcase and management platform with product catalog features.",
      technologies: "React | MongoDB | Express | Node.js",
      link: "http://samrat-frame.vercel.app/",
      github: "https://github.com/Mandip69/Samrat-Frame",
    },
    {
      id: 3,
      title: "Ex Stock",
      img: IMG3,
      description: "Stock market simulation and trading web app with real-time updates.",
      technologies: "React | WebSocket | Tailwind | Node.js",
      link: "https://github.com/Mandip69/Ex-stock",
      github: "https://github.com/Mandip69/Ex-stock",
    },
    {
      id: 4,
      title: "EyeMate",
      img: IMG4,
      description: "Eyewear e-commerce website with authentication, cart and product browsing.",
      technologies: "React | Express | MongoDB | Node.js",
      link: "https://eyemate.vercel.app/",
      github: "https://github.com/Mandip69/EyeMate",
    },
    {
      id: 5,
      title: "Real Estate",
      img: IMG5,
      description: "Real estate listing platform with property details and search functionality.",
      technologies: "Next.js | Tailwind | Firebase",
      link: "https://real-estate-tau-dun-60.vercel.app/",
      github: "https://github.com/Mandip69/Real-estate",
    },
    {
      id: 6,
      title: "Explore Nepal",
      img: IMG6,
      description: "Interactive travel platform showcasing Nepal’s destinations with filters and stories.",
      technologies: "React | Tailwind | REST API",
      link: "https://explore-nepal-three.vercel.app/",
      github: "https://github.com/Mandip69/Explore-Nepal",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {projects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
